import React, { useState } from 'react';
import './Contact.css';

const SERVICES_OPTIONS = [
  'Climatisation — Installation',
  'Climatisation — Entretien / Dépannage',
  'Pompe à chaleur — Installation',
  'Pompe à chaleur — Entretien',
  'Ventilation — Installation',
  'Ventilation — Entretien / Dépannage',
  'Devis rénovation énergétique',
  'Autre',
];

const PROPERTY_TYPES = [
  'Appartement',
  'Maison',
  'Local commercial',
  'Bureau',
  'Immeuble',
  'Autre',
];

const BUDGET_OPTIONS = [
  'Moins de 1 000 €',
  '1 000 € à 3 000 €',
  '3 000 € à 6 000 €',
  '6 000 € à 10 000 €',
  'Plus de 10 000 €',
  'À définir',
];

export default function Contact() {
  const [form, setForm] = useState({
    prenom: '',
    nom: '',
    email: '',
    telephone: '',
    societe: '',
    ville: '',
    codePostal: '',
    service: '',
    typeBien: '',
    budget: '',
    urgence: 'Non',
    consentement: false,
    message: '',
    website: '', // honeypot
  });

  const [status, setStatus] = useState({
    loading: false,
    success: false,
    error: '',
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const resetForm = () => {
    setForm({
      prenom: '',
      nom: '',
      email: '',
      telephone: '',
      societe: '',
      ville: '',
      codePostal: '',
      service: '',
      typeBien: '',
      budget: '',
      urgence: 'Non',
      consentement: false,
      message: '',
      website: '',
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setStatus({
      loading: true,
      success: false,
      error: '',
    });

    try {
      const response = await fetch('/api/contact.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(form),
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(
          data.message || "Une erreur est survenue lors de l'envoi."
        );
      }

      setStatus({
        loading: false,
        success: true,
        error: '',
      });

      resetForm();
    } catch (error) {
      setStatus({
        loading: false,
        success: false,
        error: error.message || "Impossible d'envoyer votre demande.",
      });
    }
  };

  return (
    <section id="contact" className="contact">
      <div className="contact__bg" />
      <div className="container">
        <div className="contact__grid">
          <div className="contact__info">
            <div
              className="about__label"
              style={{ color: 'rgba(255,255,255,0.6)' }}
            >
              CONTACT
            </div>

            <h2 className="section-title contact__title">
              DEMANDEZ
              <br />
              <span className="contact__accent">VOTRE DEVIS</span>
              <br />
              GRATUIT
            </h2>

            <p className="contact__desc">
              Notre équipe vous répond sous 24h pour étudier votre besoin en
              climatisation, pompe à chaleur ou ventilation, et vous proposer
              une solution claire, adaptée et sans engagement.
            </p>

            <div className="contact__details">
              <a href="tel:+33618011895" className="contact__detail">
                <div className="contact__detail-icon">
                  <svg
                    width="20"
                    height="20"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.89 9.11 19.79 19.79 0 01.82.5 2 2 0 012.81 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L7.09 7.91a16 16 0 006 6l.91-1a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z" />
                  </svg>
                </div>
                <div>
                  <strong>Téléphone</strong>
                  <span>06 18 01 18 95</span>
                </div>
              </a>

              <a href="mailto:soclimate.95@gmail.com" className="contact__detail">
                <div className="contact__detail-icon">
                  <svg
                    width="20"
                    height="20"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                </div>
                <div>
                  <strong>Email</strong>
                  <span>soclimate.95@gmail.com</span>
                </div>
              </a>

              <div className="contact__detail">
                <div className="contact__detail-icon">
                  <svg
                    width="20"
                    height="20"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                </div>
                <div>
                  <strong>Zone d'intervention</strong>
                  <span>Île-de-France (75, 77, 78, 91, 92, 93, 94, 95)</span>
                </div>
              </div>

              <div className="contact__detail">
                <div className="contact__detail-icon">
                  <svg
                    width="20"
                    height="20"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                </div>
                <div>
                  <strong>Horaires</strong>
                  <span>Lun–Ven : 8h–18h · Sam : 9h–13h</span>
                </div>
              </div>
            </div>
          </div>

          <div className="contact__form-wrap">
            {status.success ? (
              <div className="contact__success">
                <div className="contact__success-icon">✓</div>
                <h3>Demande envoyée</h3>
                <p>
                  Merci pour votre message. Nous reviendrons vers vous dans les
                  plus brefs délais.
                </p>
                <button
                  className="btn-primary"
                  type="button"
                  onClick={() =>
                    setStatus({ loading: false, success: false, error: '' })
                  }
                >
                  Envoyer une nouvelle demande
                </button>
              </div>
            ) : (
              <form className="contact__form" onSubmit={handleSubmit}>
                <h3 className="contact__form-title">Formulaire de contact</h3>

                <div className="contact__row">
                  <div className="contact__field">
                    <label>Prénom *</label>
                    <input
                      type="text"
                      name="prenom"
                      value={form.prenom}
                      onChange={handleChange}
                      placeholder="Jean"
                      required
                    />
                  </div>

                  <div className="contact__field">
                    <label>Nom *</label>
                    <input
                      type="text"
                      name="nom"
                      value={form.nom}
                      onChange={handleChange}
                      placeholder="Dupont"
                      required
                    />
                  </div>
                </div>

                <div className="contact__row">
                  <div className="contact__field">
                    <label>Email *</label>
                    <input
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      placeholder="jean.dupont@email.com"
                      required
                    />
                  </div>

                  <div className="contact__field">
                    <label>Téléphone *</label>
                    <input
                      type="tel"
                      name="telephone"
                      value={form.telephone}
                      onChange={handleChange}
                      placeholder="06 12 34 56 78"
                      required
                    />
                  </div>
                </div>

                <div className="contact__row">
                  <div className="contact__field">
                    <label>Société</label>
                    <input
                      type="text"
                      name="societe"
                      value={form.societe}
                      onChange={handleChange}
                      placeholder="Nom de votre société"
                    />
                  </div>

                  <div className="contact__field">
                    <label>Ville</label>
                    <input
                      type="text"
                      name="ville"
                      value={form.ville}
                      onChange={handleChange}
                      placeholder="Votre ville"
                    />
                  </div>
                </div>

                <div className="contact__row">
                  <div className="contact__field">
                    <label>Code postal</label>
                    <input
                      type="text"
                      name="codePostal"
                      value={form.codePostal}
                      onChange={handleChange}
                      placeholder="95100"
                    />
                  </div>

                  <div className="contact__field">
                    <label>Type de bien</label>
                    <select
                      name="typeBien"
                      value={form.typeBien}
                      onChange={handleChange}
                    >
                      <option value="">Sélectionnez</option>
                      {PROPERTY_TYPES.map((item) => (
                        <option key={item} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="contact__row">
                  <div className="contact__field">
                    <label>Type de prestation *</label>
                    <select
                      name="service"
                      value={form.service}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Sélectionnez un service...</option>
                      {SERVICES_OPTIONS.map((service) => (
                        <option key={service} value={service}>
                          {service}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="contact__field">
                    <label>Budget estimatif</label>
                    <select
                      name="budget"
                      value={form.budget}
                      onChange={handleChange}
                    >
                      <option value="">Sélectionnez</option>
                      {BUDGET_OPTIONS.map((item) => (
                        <option key={item} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="contact__row">
                  <div className="contact__field">
                    <label>Demande urgente ?</label>
                    <select
                      name="urgence"
                      value={form.urgence}
                      onChange={handleChange}
                    >
                      <option value="Non">Non</option>
                      <option value="Oui">Oui</option>
                    </select>
                  </div>

                  <div className="contact__field contact__field--hidden">
                    <label>Website</label>
                    <input
                      type="text"
                      name="website"
                      value={form.website}
                      onChange={handleChange}
                      autoComplete="off"
                      tabIndex="-1"
                    />
                  </div>
                </div>

                <div className="contact__field">
                  <label>Votre message *</label>
                  <textarea
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    placeholder="Décrivez votre projet, votre besoin, la surface, le problème rencontré ou toute précision utile..."
                    rows={6}
                    required
                  />
                </div>

                <label className="contact__checkbox">
                  <input
                    type="checkbox"
                    name="consentement"
                    checked={form.consentement}
                    onChange={handleChange}
                    required
                  />
                  <span>
                    J’accepte que mes informations soient utilisées pour être
                    recontacté dans le cadre de ma demande. *
                  </span>
                </label>

                {status.error && (
                  <div className="contact__error">{status.error}</div>
                )}

                <button
                  type="submit"
                  className="btn-primary contact__submit"
                  disabled={status.loading}
                >
                  <svg
                    width="18"
                    height="18"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <line x1="22" y1="2" x2="11" y2="13" />
                    <polygon points="22 2 15 22 11 13 2 9 22 2" />
                  </svg>
                  {status.loading ? 'Envoi en cours...' : 'Envoyer ma demande'}
                </button>

                <p className="contact__privacy">
                  🔒 Vos données sont confidentielles et utilisées uniquement
                  pour traiter votre demande.
                </p>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}